// Search Global

// searchglobal__wrapper
// Setting Focus on input

var fn_search_global = function () {

  var searchGlobalWrapper = $("#searchglobal__wrapper");
  var searchGlobalToggler = $("#searchglobal__wrapper .searchglobal__toggler");
  var searchGlobalinput = $("#searchglobal__wrapper #searchglobal__input");


  function modal__backdrop() {
    $('body .modal-backdrop').addClass('bg-white').css('z-index','var(--zindex-z-dropdown)');
  }
  function modal__backdrop_clear() {
    $('body .modal-backdrop').removeClass('bg-white').css('z-index','');
  }


  $(searchGlobalWrapper).on('shown.bs.modal', function () {
    // do something...
    modal__backdrop();
    setTimeout(function () {
      $(searchGlobalinput).focus();
     }, 180);

  })
  $(searchGlobalWrapper).on('hide.bs.modal', function () {
    // do something...
    modal__backdrop_clear();
  })
  $(searchGlobalWrapper).on('hidden.bs.modal', function () {
    // do something...
    $(searchGlobalinput).blur();
  })


};
